/**
 * @file index.jsx
 * @brief Thin wrapper that renders the listing form in edit mode.
 */
import ListingForm from "../ListingForm";

/**
 * Render the edit listing route using the shared listing form component.
 * @returns {JSX.Element} Listing form configured for editing.
 */
export default function EditListing() {
    return <ListingForm mode="edit" />;
}
